import { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { AuthContext } from '../context/authContext.jsx';
import { initiateSocketConnection } from '../service/socketio.js';

// Roles que reciben la burbuja de alertas de Obras (migración 085).
// 'admin' NO está: entra a la página desde su menú Admin, sin burbuja.
export const ROLES_ALERTA_OBRAS = ['seguimiento_obras'];

// Pendientes de alertas de Obras: carga al montar, poll silencioso y refresco
// por socket ('alertas_obras_actualizadas').
export const useAlertasObras = ({ intervaloMs = 60000 } = {}) => {
    const { token, role, roles } = useContext(AuthContext);

    const [pendientes, setPendientes] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState('');

    const puede = useMemo(() => {
        if (!role) return false;
        if (Array.isArray(roles) && roles.some((r) => ROLES_ALERTA_OBRAS.includes(r))) return true;
        return ROLES_ALERTA_OBRAS.includes(role);
    }, [role, roles]);

    const recargar = useCallback(async () => {
        if (!puede || !token) return [];
        setCargando(true);
        try {
            const res = await fetch('/api/alertas-obras/pendientes', {
                headers: { Authorization: `Bearer ${token}` },
                cache: 'no-store',
            });
            if (!res.ok) {
                setError('No se pudieron cargar las alertas');
                setPendientes([]);
                return [];
            }
            const data = await res.json();
            const lista = data?.data || [];
            setPendientes(lista);
            setError('');
            return lista;
        } catch (e) {
            console.error('[alertas obras] error:', e);
            setError(e.message);
            return [];
        } finally {
            setCargando(false);
        }
    }, [puede, token]);

    useEffect(() => {
        recargar();
    }, [recargar]);

    useEffect(() => {
        if (!puede || !token) return undefined;
        const s = initiateSocketConnection();
        const onActualizada = () => recargar();
        s.on('alertas_obras_actualizadas', onActualizada);
        const id = setInterval(() => recargar(), intervaloMs);
        return () => {
            s.off('alertas_obras_actualizadas', onActualizada);
            clearInterval(id);
        };
    }, [puede, token, recargar, intervaloMs]);

    return { pendientes, cargando, error, puede, recargar };
};
